export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";